import { FC } from 'react'
import { FormControl, InputLabel, MenuItem, Select as SelectComponent } from '@mui/material'

export const Select: FC<ISelect> = ({
  label = '',
  options = [],
  onChange,
  value,
  fullWidth = true
}) => {
  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabel id='provider-select-label' color='warning'>
        {label}
      </InputLabel>
      <SelectComponent
        labelId='provider-select-label'
        color='warning'
        fullWidth={fullWidth}
        value={value}
        label={label}
        onChange={event => onChange(event?.target?.value)}
      >
        {options?.map(ppO => (
          <MenuItem key={`menu_item_${ppO.label}`} value={ppO.value}>
            {ppO.label}
          </MenuItem>
        ))}
      </SelectComponent>
    </FormControl>
  )
}

type ValueType = string | number

type SelectOptionType = {
  value: ValueType
  label: string
}

interface ISelect {
  label?: string
  value?: ValueType
  onChange: (value: ValueType) => void
  options: SelectOptionType[]
  fullWidth?: boolean
}
